export const cards = [
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },
  {
    content: 'Направление включает в себя исследования и разработки технологий МО и КТ. Модули для внедрения в предметные сетевые программы магистратуры с элементами МО и КТ, илипрограммы ДПО.'
  },


  
];